import "reflect-metadata";
export function Adapter<DTO, T>({
  classRef,
}: {
    classRef: (new (model?: Partial<DTO>) => T);
}): ClassDecorator {
  // eslint-disable-next-line @typescript-eslint/ban-types
  return (constructor: Function) => {
    Reflect.defineMetadata("classRef", classRef, constructor.prototype);
  };
}
